/**
 * 创建文件列表
 * @param {Array} files 文件 URL 或文件对象数组
 * @param {String} prefix 文件前缀
 * @param {String} baseName 文件基础名称
 * @returns {Array} 文件列表
 */
export function createFileList(files, prefix = "文件", baseName = "文件") {
  if (!files || !Array.isArray(files) || files.length === 0) {
    return [];
  }
  return files
    .map((file, index) => {
      const fileObject = file && typeof file === "object" ? file : {};
      const originUrl =
        typeof file === "string"
          ? file
          : fileObject.originUrl || fileObject.url || fileObject.fileUrl;
      if (!originUrl) return null;

      const originalName =
        fileObject.originalName || fileObject.name || fileObject.fileName;
      const isPdf = String(originalName || originUrl)
        .split(/[?#]/)[0]
        .toLowerCase()
        .endsWith(".pdf");
      return {
        ...fileObject,
        uid: fileObject.uid || `${prefix}-${index}`,
        name:
          originalName ||
          (isPdf
            ? `${baseName}${index + 1}.pdf`
            : `${baseName}图片${index + 1}`),
        originalName: originalName || undefined,
        url: isPdf
          ? "https://img.icons8.com/color/96/000000/pdf.png"
          : originUrl,
        originUrl, // 保存原始 URL 用于预览
      };
    })
    .filter(Boolean);
}

/**
 * 将接口历史 URL 或上传组件文件对象统一为标准附件对象。
 * 对象型附件保留原有所有字段，并统一补齐 originalName 和真实 OSS 地址。
 * @param {Array|Object|String} files 文件列表、单个文件对象或历史字符串
 * @param {String} fallbackName 无法从数据或 URL 获取名称时的默认名称
 * @returns {Array<Object>} 保留原字段的标准附件对象列表
 */
export function normalizeAttachmentFiles(files, fallbackName = "附件") {
  let source = files;

  if (typeof source === "string") {
    const value = source.trim();
    if (!value) return [];
    try {
      const parsed = JSON.parse(value);
      source = Array.isArray(parsed) ? parsed : [parsed];
    } catch (error) {
      source = value
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean);
    }
  } else if (!Array.isArray(source)) {
    source = source ? [source] : [];
  }

  return source
    .map((file) => {
      const fileObject = file && typeof file === "object" ? file : {};
      const url =
        typeof file === "string"
          ? file.trim()
          : fileObject.originUrl ||
            fileObject.fileUrl ||
            (fileObject.response && fileObject.response.url) ||
            fileObject.url;
      if (!url) return null;

      return {
        ...fileObject,
        originalName:
          fileObject.originalName ||
          fileObject.name ||
          fileObject.fileName ||
          getFileNameFromUrl(url) ||
          fallbackName,
        url,
      };
    })
    .filter(Boolean);
}

function getFileNameFromUrl(url) {
  const cleanUrl = String(url || "").split(/[?#]/)[0];
  const fileName = cleanUrl.substring(cleanUrl.lastIndexOf("/") + 1);
  try {
    return fileName ? decodeURIComponent(fileName) : "";
  } catch (error) {
    return fileName;
  }
}
